export enum NotificationTypes {
    PlatformMessage = "platform_message",
    ConnectionRequest = "connection_request",
    ConnectionAction = "connection_action",
    StartupSuggestion = "startup_suggestion",
    InvestorSuggestion = "investor_suggestion",
    // SAN-1766 — someone applied to a job the user's team posted
    JobApplication = "job_application",
    // SAN-1769 — live items: counted by the bell, no notifications row
    LiveProgram = "live_program",
    LiveChallenge = "live_challenge",
    LiveEvent = "live_event",
    LiveWallPost = "live_wall_post",
    LiveMeeting = "live_meeting",
    // SAN-1471 (EX-04) — the user's own application changed status
    CfaApplicationStatus = "cfa_application_status",
    ProgramApplicationStatus = "program_application_status",
    VsProgramApplicationStatus = "vs_program_application_status",
    MentorApplicationStatus = "mentor_application_status",
    JobApplicationStatus = "job_application_status",
    // SAN-1472 (EX-05) — 24 h / 1 h reminder before an event the user registered for
    EventReminder = "event_reminder",
    // SAN-1470 (EX-03) — activity on the user's own wall posts and comments
    PostComment = "post_comment",
    CommentReply = "comment_reply",
    PostReaction = "post_reaction",
}

// SAN-1470 — icon per community activity type, shared by the bell panel and
// the /notifications page. A click marks it read and opens its `url`
// (/community-feed/posts/post/…).
export const COMMUNITY_ACTIVITY_ICONS: { [type: string]: string } = {
    [NotificationTypes.PostComment]: 'bi-chat-left-text',
    [NotificationTypes.CommentReply]: 'bi-reply',
    [NotificationTypes.PostReaction]: 'bi-hand-thumbs-up',
};

// SAN-1472 — icon for an event reminder, shared by the bell panel and the
// /notifications page. A click marks it read and opens its `url`
// (/calender/events?eventId=…).
export const EVENT_REMINDER_ICON = 'bi-calendar-event';

// SAN-1471 — icon per application status type, shared by the bell panel and
// the /notifications page. An action-required item of these types carries
// `cta: { label, url } | null` from the backend; any other item has no `cta`.
export const APPLICATION_STATUS_ICONS: { [type: string]: string } = {
    [NotificationTypes.CfaApplicationStatus]: 'bi-clipboard-check',
    [NotificationTypes.ProgramApplicationStatus]: 'bi-clipboard-check',
    [NotificationTypes.VsProgramApplicationStatus]: 'bi-clipboard-check',
    [NotificationTypes.MentorApplicationStatus]: 'bi-person-badge',
    [NotificationTypes.JobApplicationStatus]: 'bi-file-earmark-check',
};

export function isApplicationStatusType(type: string): boolean {
    return !!APPLICATION_STATUS_ICONS[type];
}